import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { useStatusColor } from "../../../hooks";
import { TASK_OVERVIEW_STATUSES } from "../../../types";
import ProgressBarTitle from "../../ProgressBarTitle";
import { TooltipContentProps } from "./types";

const TooltipContent = ({
    status,
    timeframe,
    taskEntries
}: TooltipContentProps) => {
    const { gray700, gray200 } = colors;

    const { t } = useTranslation();
    const { getStatusColor } = useStatusColor();

    const isNoTasks = status === TASK_OVERVIEW_STATUSES.NoTasks;

    return (
        <div
            css={css({
                color: gray700,
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                letterSpacing: "0.1px"
            })}
        >
            <div>
                <div css={css({ display: "flex", alignItems: "center" })}>
                    <span
                        css={css({
                            display: "block",
                            width: "8px",
                            height: "8px",
                            borderRadius: "100px",
                            marginRight: "8px",
                            background: getStatusColor(status)
                        })}
                    />

                    <span
                        css={css({
                            fontWeight: "500"
                        })}
                    >
                        <ProgressBarTitle status={status} />
                    </span>
                </div>

                <div>{t(`Dashboard##tasks##${timeframe}##tooltipTitle`)}</div>
            </div>

            {!isNoTasks && (
                <>
                    <div
                        css={css({
                            height: "1px",
                            backgroundColor: gray200,
                            margin: "4px 0"
                        })}
                    />

                    <ul
                        css={css({
                            maxHeight: "140px",
                            overflowY: "auto",
                            marginRight: "-16px",
                            padding: "0 16px",

                            "& > li": {
                                listStyle: "disc"
                            },

                            "& > li + li": {
                                marginTop: "4px"
                            }
                        })}
                    >
                        {taskEntries.map(({ type, count }) => (
                            <li key={type}>
                                <span>{t(`General##${type}`)}</span>:{" "}
                                <span css={css({ fontWeight: "500" })}>
                                    {count}
                                </span>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default TooltipContent;
